import {
    FormAnswerDto,
    FormAnswerListItemDto,
} from "../models/formAnswer/formAnswerListItemDto";
import { ApiResponse, apiCall } from "./apiClient";

export const getFormAnswers = (
    params: {
        startDate?: string;
        endDate?: string;
        relatedObjectType?: string;
        relatedObjectIds?: string[];
        formTemplateIds?: string[];
        answeredByEmployeeIds?: string[];
    },
    signal?: AbortSignal
): Promise<ApiResponse<FormAnswerListItemDto[]>> => {
    return apiCall<FormAnswerListItemDto[], typeof params>(
        "FormAnswers",
        "GET",
        params,
        signal
    );
};

export const getRelatedObjectIdsWithAnswers = (
    relatedObjectType: string,
    signal?: AbortSignal
): Promise<ApiResponse<string[]>> => {
    return apiCall<string[], { relatedObjectType: string }>(
        "FormAnswers/relatedObjectIdsWithAnswers",
        "GET",
        { relatedObjectType },
        signal
    );
};

export const getFormAnswer = (
    id: string,
    signal?: AbortSignal
): Promise<ApiResponse<FormAnswerDto>> => {
    return apiCall<FormAnswerDto>(
        `FormAnswers/${encodeURIComponent(id)}`,
        "GET",
        null,
        signal
    );
};
